import type {
  PhysicalCountDetailGroupKey,
  PhysicalCountSessionSummary,
} from '../../../types/physicalCount.types';

export type PhysicalCountGroupAccent = 'success' | 'error' | 'warning' | 'info';

export interface PhysicalCountDetailGroupConfig {
  key: PhysicalCountDetailGroupKey;
  label: string;
  accent: PhysicalCountGroupAccent;
  getCount: (summary: PhysicalCountSessionSummary) => number;
  helperText?: string;
}

export const PHYSICAL_COUNT_DETAIL_GROUPS: PhysicalCountDetailGroupConfig[] = [
  {
    key: 'success',
    label: 'Coincidencias',
    accent: 'success',
    getCount: (s) => s.okCount,
  },
  {
    key: 'missing',
    label: 'Faltantes',
    accent: 'error',
    getCount: (s) => s.missingCount,
    helperText: 'Solo consulta. Para confirmar faltantes use el icono en el listado de sesiones.',
  },
  {
    key: 'excess',
    label: 'Sobrantes',
    accent: 'warning',
    getCount: (s) => s.surplusCount,
  },
  {
    key: 'scanned_not_available',
    label: 'No disponibles',
    accent: 'info',
    getCount: (s) => s.scannedNotAvailableCount ?? 0,
  },
  {
    key: 'duplicate',
    label: 'Duplicados',
    accent: 'warning',
    getCount: (s) => s.duplicateCount,
  },
];

export const PHYSICAL_COUNT_ITEMS_PAGE_SIZE = 10;

export const PHYSICAL_COUNT_GROUP_KEYS: PhysicalCountDetailGroupKey[] = [
  'success',
  'missing',
  'excess',
  'scanned_not_available',
  'duplicate',
];
